//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "custom-number-input",
  props: {
    value: {
      type: Number
    }
  },
  methods: {
    onMinusClick(){
      if(this.$refs.numberInput.value > 1){
        this.$refs.numberInput.value--
        this.$emit('input', parseInt(this.$refs.numberInput.value))
      }
    },
    onPlusClick(){
      this.$refs.numberInput.value++
      this.$emit('input', parseInt(this.$refs.numberInput.value))
    },
    updateValue(value) {
      if(value < 1) {
        value = 1
        this.$refs.numberInput.value = "1"
      }

      this.$emit('input', parseInt(value))
    }
  }
}
